<template>
    <div>
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="tableData"
            :sort-by="'created_at'"
            :sort-desc="true">
            <template v-slot:cell(created_at)="data">
                {{ data.item.created_at | date_time_om }}
            </template>
            <template v-slot:cell(actions)="data">
                <b-button
                    class="btn-show btn-view-invite"
                    variant="primary-icon-only"
                    @click="showLogModal(data.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-show-group-pair-log-modal-component ref="show-log-modal">
        </design-2021-show-group-pair-log-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-log-component',
    props: {
        activitiesIn: Array,
    },
    data() {
        return {
            fields: [
                {
                    key: 'causer.full_name',
                    label: this.$t('common.by'),
                },
                {
                    key: 'action',
                    label: this.$t('common.activity'),
                },
                {
                    key: 'created_at',
                    label: this.$t('common.date'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.activitiesIn.map((activity) => {
                let actie = activity.description;
                switch (activity.description) {
                    case 'store':
                        actie = this.$t('group_pair.first_request');
                        break;
                    case 'reopen':
                        actie = this.$t('group_pair.reopened');
                        break;
                    case 'update':
                        actie = this.$t('group_pair.adapted_request');
                        break;
                    case 'accepted by teacher':
                        actie = this.$t('group_pair.accepted_by_teacher');
                        break;
                    case 'rejected by teacher':
                        actie = this.$t('group_pair.refused_by_teacher');
                        break;
                    case 'accepted by both teacher and Coordinator':
                        actie = this.$t('group_pair.accepted_by_teacher_and_coordinator');
                        break;
                    case 'rejected by teacher or Coordinator':
                        actie = this.$t('group_pair.refused_by_teacher_or_coordinator');
                        break;
                    case 'accepted by teacher or Coordinator but not by the other yet':
                        actie = this.$t('group_pair.accepted_by_teacher_or_coordinator');
                        break;
                    case 'accepted by Coordinator':
                        actie = this.$t('group_pair.accepted_by_coordinator');
                        break;
                    case 'rejected by Coordinator':
                        actie = this.$t('group_pair.refused_by_coordinator');
                        break;
                    case 'feedback given':
                        actie = this.$t('group_pair.feedback_given');
                        break;
                }
                return {
                    causer: activity.causer,
                    action: actie,
                    courses: activity.properties.courses,
                    students: activity.properties.students,
                    teachers: activity.properties.teachers,
                    subject: activity.properties.subject,
                    explanation: activity.properties.explanation,
                    feedback: activity.properties.feedback,
                    created_at: activity.created_at,
                };
            });
        },
    },
    methods: {
        showLogModal(log) {
            this.$refs['show-log-modal'].show(log);
        },
    },
};
</script>

<style scoped lang="scss"></style>
